import React from "react";
import Backicon from "../../../shared/components/Backicon/Backicon";
import styles from "./doctorappointments.module.css";
import Header from "../../../shared/components/Header/Header";
import basestyles from "../../../shared/styles/basestyles.module.css";

class DoctorAppointments extends React.Component {
  state = {
    patientAppointmentOverview: "",
  };

  componentDidMount() {
    let appointments = JSON.parse(localStorage.getItem("patient_appointment"));
    this.setState({
      patientAppointmentOverview: appointments ? appointments.data : [],
    });
  }

  render() {
    return (
      <>
        <div className={styles.backgroundpic}>
          <Backicon
            onClick={() => this.props.history.goBack()}
            style={{
              background:
                "linear-gradient(60deg, rgba(2, 12, 29, 0.644) 0%, rgba(67, 184, 192, 0.548) 98%)",
              color: "white",
            }}
          />
          <div className={basestyles.inputWidth}>
            <Header name="All Appointments" />
            <div className={styles.allapt}>
              <table>
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Name</th>
                    <th>Phone</th>
                    <th>Problem</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.patientAppointmentOverview &&
                    this.state.patientAppointmentOverview.map((appointment) => (
                      <tr key={appointment.id}>
                        <td>{appointment.id}</td>
                        <td>{appointment.Name}</td>
                        <td>{appointment.Phone}</td>
                        <td>{appointment.TypeOfProblemHeSheIsFacing}</td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default DoctorAppointments;
